export default __webpack_public_path__ + "static/media/redhat.eb1968c3.svg";